export const ANALYTICS_CHANNEL = 'navigation';
export const ANALYTICS_TAG = 'navigationExperiences';
export const NAV_LAYER = 'global';
export const NAV_CONTAINER = 'top';
export const NAV_VERSION = 4;
export const ANALYTICS_SOURCE = 'topNav';
export const ATI_PRESETS = {
	LOOM: 'ati:cloud:loom:video',
	GOAL: 'ati:cloud:townsquare:goal',
	TEAM: 'ati:cloud:townsquare:team',
	PROJECT: 'ati:cloud:townsquare:project',
};

/**
 * @deprecated Use ATI_PRESETS.LOOM instead.
 */
export const LOOM_ATI = ATI_PRESETS.LOOM;
